import { isAfter } from 'date-fns';
import head from 'lodash/head';
import { z } from 'zod';

export const windcaveTransactionSchema = z
  .object({
    id: z.string(),
    authorised: z.boolean(),
    card: z.object({
      id: z.string(),
      cardHolderName: z.string(),
      cardNumber: z.string(),
      dateExpiryMonth: z.string(),
      dateExpiryYear: z.string(),
      type: z.string(),
    }),
  })
  .transform((data) => ({
    paymentType: 'creditCard',
    cardType: data.card.type,
    cardHolderName: data.card.cardHolderName,
    truncatedCardNumber: data.card.cardNumber,
    token: data.card.id,
    gatewayKey: 'pxpay',
    termsAndConditionsAcceptedAt: new Date().toString(),
    preferred: true,
    expiryDate: {
      month: data.card.dateExpiryMonth,
      year: `20${data.card.dateExpiryYear}`,
    },
  }));

export const windcaveGetSessionSchema = z.object({
  id: z.string(),
  expires: z.string(),
  transactions: z.array(windcaveTransactionSchema),
});

export const parsedWindcaveGetSessionSchema =
  windcaveGetSessionSchema.transform((data) => {
    const expiry = new Date(data.expires);
    const isExpired = isAfter(new Date(), expiry);

    if (isExpired) {
      return {
        id: data.id,
        isExpired,
      };
    }

    return {
      id: data.id,
      isExpired,
      card: head(data.transactions),
    };
  });

export type WindcaveGetSessionSchema = z.infer<typeof windcaveGetSessionSchema>;
export type ParsedWindcaveGetSessionSchema = z.infer<
  typeof parsedWindcaveGetSessionSchema
>;
export type SessionType = Pick<
  ParsedWindcaveGetSessionSchema,
  'card' | 'id' | 'isExpired'
>;
